import { ApiCampaignPopupRule } from "./types";

export interface ResolveUtmParams {
  utm_campaign: string;
  utm_source?: string;
  utm_medium?: string;
}

function campaignList(rule: ApiCampaignPopupRule): string[] {
  const c = rule.campaign;
  if (Array.isArray(c)) return c.map((x) => String(x).trim()).filter(Boolean);
  return c ? [String(c).trim()] : [];
}

/**
 * Mirrors lemonade-front resolve: no match without utm_campaign; case-insensitive
 * campaign; skip enabled===false; utm_source/medium on rule must match when set.
 */
export function resolvePopupFromRules(
  rules: ApiCampaignPopupRule[],
  params: ResolveUtmParams
): ApiCampaignPopupRule | null {
  const utmCampaign = params.utm_campaign?.trim();
  if (!utmCampaign) return null;

  const reqCampaign = utmCampaign.toLowerCase();
  const reqSource = (params.utm_source || "").trim().toLowerCase();
  const reqMedium = (params.utm_medium || "").trim().toLowerCase();

  for (const rule of rules) {
    if (rule.enabled === false) continue;

    const matchesCampaign = campaignList(rule).some(
      (c) => c.toLowerCase() === reqCampaign
    );
    if (!matchesCampaign) continue;

    if (rule.utm_source != null && String(rule.utm_source).trim() !== "") {
      if (String(rule.utm_source).trim().toLowerCase() !== reqSource) continue;
    }
    if (rule.utm_medium != null && String(rule.utm_medium).trim() !== "") {
      if (String(rule.utm_medium).trim().toLowerCase() !== reqMedium) continue;
    }

    return rule;
  }

  return null;
}
